import Text from '../../../atoms/Text';
import { onCopyAddress, onTokenScan } from '../../../helpers/addressUtils';

import './styles.scss';

interface ITableContractField {
  address: string;
  chain: string;
  textSize?: number;
}

const TableContractField = ({
  address,
  chain,
  textSize = 12,
}: ITableContractField) => {
  const fmt = `${address.slice(0, 6)}...${address.slice(address.length - 4)}`;

  return (
    <div className='contract__cell'>
      <Text size={textSize} className='text--navy-600'>
        {fmt}
      </Text>
      <div
        className='contract__cell__icon icon-copy'
        onClick={(e) => onCopyAddress(address, e)}
      />
      <div
        className='contract__cell__icon icon-top-right-square'
        onClick={(e) => onTokenScan(address, chain, e)}
      />
    </div>
  );
};

export default TableContractField;
